import React from "react";
import { NavLink, Outlet, useNavigate } from "react-router-dom";
import {
  SquaresFour, ChatCircleDots, Cube, Receipt, Key, SignOut, Sparkle, Robot, ImageSquare, Bank, Calculator,
} from "@phosphor-icons/react";
import { useAuth } from "@/context/AuthContext";

const NAV = [
  { to: "/dashboard", label: "Overview", icon: SquaresFour, end: true, testid: "nav-overview" },
  { to: "/dashboard/workspace", label: "AI Workspace", icon: ChatCircleDots, testid: "nav-workspace" },
  { to: "/dashboard/builder", label: "App Builder", icon: Cube, testid: "nav-builder" },
  { to: "/dashboard/agents", label: "AI Agents", icon: Robot, testid: "nav-agents" },
  { to: "/dashboard/media", label: "Media Studio", icon: ImageSquare, testid: "nav-media" },
  { to: "/dashboard/taxos", label: "TaxOS", icon: Receipt, testid: "nav-taxos" },
  { to: "/dashboard/accounting", label: "Accounting", icon: Calculator, testid: "nav-accounting" },
  { to: "/dashboard/gstos", label: "GST OS", icon: Bank, testid: "nav-gstos" },
  { to: "/dashboard/api", label: "Zeyrodha Universal API Key", icon: Key, testid: "nav-api" },
];

export default function DashboardShell() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex bg-[#FCFAF8]">
      {/* Sidebar */}
      <aside className="w-64 shrink-0 bg-[#F9F6F4] border-r border-[#2A2625]/10 flex flex-col fixed h-screen">
        <button
          onClick={() => navigate("/dashboard")}
          data-testid="sidebar-logo"
          className="flex items-center gap-2 px-6 h-16 border-b border-[#2A2625]/10"
        >
          <img src="/clover-logo.png" alt="Zeyrodha.AI" className="w-8 h-8 object-contain" />
          <span className="font-display text-lg font-semibold tracking-tight">Zeyrodha<span className="text-[#2F9E5A]">.AI</span></span>
        </button>

        <nav className="flex-1 px-3 py-5 space-y-1">
          {NAV.map((n) => (
            <NavLink
              key={n.to}
              to={n.to}
              end={n.end}
              data-testid={n.testid}
              className={({ isActive }) =>
                `flex items-center gap-3 px-3 py-2.5 rounded-xl text-sm font-medium transition-colors ${
                  isActive
                    ? "bg-[#FFB8A5]/40 text-[#2A2625]"
                    : "text-[#594F4D] hover:bg-[#2A2625]/5 hover:text-[#2A2625]"
                }`
              }
            >
              <n.icon size={20} weight="duotone" />
              {n.label}
            </NavLink>
          ))}
        </nav>

        <div className="p-3 border-t border-[#2A2625]/10">
          <div className="flex items-center gap-3 px-2 py-2">
            {user?.picture ? (
              <img src={user.picture} alt="" className="w-9 h-9 rounded-full object-cover" referrerPolicy="no-referrer" />
            ) : (
              <div className="w-9 h-9 rounded-full bg-[#FFB8A5] flex items-center justify-center font-display font-semibold">
                {user?.name?.[0] || "U"}
              </div>
            )}
            <div className="min-w-0 flex-1">
              <p className="text-sm font-semibold truncate">{user?.name || "User"}</p>
              <p className="text-xs text-[#8C8381] truncate">{user?.email}</p>
            </div>
          </div>
          <button
            onClick={logout}
            data-testid="logout-btn"
            className="mt-2 w-full flex items-center gap-2 px-3 py-2 rounded-xl text-sm text-[#594F4D] hover:bg-[#2A2625]/5 transition-colors"
          >
            <SignOut size={18} weight="duotone" /> Sign out
          </button>
        </div>
      </aside>

      {/* Main */}
      <main className="flex-1 ml-64 min-h-screen">
        <Outlet />
      </main>
    </div>
  );
}
